
export default function LocalExpertiseSection() {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              <span className="text-teal-600">El Paso</span> Local Expertise
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              As El Paso natives and business owners ourselves, we understand the unique challenges and 
              opportunities that local small businesses face. Our team has deep knowledge of the El Paso 
              market, customer preferences, and competitive landscape.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Located at 1000 Duskin Dr, we're not just another out-of-state web design company. We're your 
              neighbors, and we're invested in the success of El Paso's small business community. When you 
              work with us, you're supporting local expertise and getting personalized service from people 
              who truly understand your market.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-2-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Local Market Knowledge</h3>
                  <p className="text-gray-600">
                    We understand El Paso demographics, search patterns, and what resonates with local customers.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Community Connection</h3>
                  <p className="text-gray-600">
                    Active in the El Paso business community with strong relationships and local partnerships.
                  </p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-xl text-teal-600"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Personal Service</h3>
                  <p className="text-gray-600">
                    Meet with us in person, get immediate responses, and work directly with decision-makers.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/0eab5545742358bcf778e9043ce5f877.jpg"
              alt="El Paso Texas local business community and skyline"
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
